import { render } from "./ButtonRank101.vue?vue&type=template&id=6a165ce1&scoped=true"
import script from "./ButtonRank101.vue?vue&type=script&lang=js"
export * from "./ButtonRank101.vue?vue&type=script&lang=js"

import "./ButtonRank101.vue?vue&type=style&index=0&id=6a165ce1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a165ce1"]])

export default __exports__